import { render, staticRenderFns } from "./RetirementChicksByCorral.vue?vue&type=template&id=07884888&scoped=true"
import script from "./RetirementChicksByCorral.vue?vue&type=script&lang=js"
export * from "./RetirementChicksByCorral.vue?vue&type=script&lang=js"
import style0 from "./RetirementChicksByCorral.vue?vue&type=style&index=0&id=07884888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07884888",
  null
  
)

export default component.exports